import React from 'react';
import Omega3BoxImage from '../../../assets/omega3/1.webp';

const Omega3ProductSelector = ({
  t,
  hasFormula,
  hasOmega3,
  hasOmega3Selected,
  onOmega3Change,
  omega3Price,
  showOmega3Selector = true,
  titleKey = 'Omega3_Card_Title',
  descriptionKey = 'CustomFormulaForm_Omega3Description',
  packagingKey = 'CustomFormulaForm_Omega3PackagingNote',
  showSelectionLabel = false,
}) => {
  if (!hasFormula || !hasOmega3 || !showOmega3Selector) return null;

  const containerClassName = hasOmega3Selected
    ? 't-border-quiz-teal t-bg-teal-bg t-shadow-[0_0_0_1px_#116D6E]'
    : 't-border-g200 t-bg-white t-shadow-sm';
  const imageClassName = hasOmega3Selected ? 't-bg-white' : 't-bg-[#f7fbf9]';
  const titleClassName = hasOmega3Selected ? 't-text-navy' : 't-text-secondary';
  const bodyClassName = hasOmega3Selected ? 't-text-navy/80' : 't-text-gray-700';
  const noteClassName = hasOmega3Selected ? 't-text-quiz-teal' : 't-text-gray-500';
  const priceClassName = hasOmega3Selected ? 't-text-navy' : 't-text-secondary';

  return (
    <div className={`t-flex t-flex-col t-gap-3 t-rounded-lg t-border t-p-4 t-mr-1 ${containerClassName}`}>
      <label className="t-flex t-w-full t-cursor-pointer t-items-start t-gap-3">
        <img
          src={Omega3BoxImage}
          alt={t(showSelectionLabel ? 'Omega3_Selection_ImageAlt' : 'CustomFormulaForm_Omega3ImageAlt')}
          className={`t-h-20 t-w-20 t-rounded-md t-object-contain t-p-1 ${imageClassName}`}
        />
        <span className="t-flex t-flex-1 t-items-start t-gap-3">
          <input
            type="checkbox"
            checked={hasOmega3Selected}
            onChange={(event) => onOmega3Change(event.target.checked)}
            className="t-mt-1 t-h-4 t-w-4 t-rounded t-border-gray-300 t-text-quaternary focus:t-ring-quaternary"
          />
          <span className="t-flex t-flex-1 t-flex-col t-gap-1">
            <span
              className={`t-flex t-items-start t-justify-between t-gap-3 ${showSelectionLabel ? 't-flex-col sm:t-flex-row' : ''}`}
            >
              <span className={`t-font-sans t-text-sm t-font-bold ${titleClassName}`}>{t(titleKey)}</span>
              <span className={`t-shrink-0 t-font-sans t-text-sm t-font-bold ${priceClassName}`}>
                {omega3Price}
              </span>
            </span>
            {showSelectionLabel && (
              <span className="t-text-xs t-font-semibold t-text-quiz-teal">
                {t(hasOmega3Selected ? 'Omega3_Selection_Selected' : 'Omega3_Selection_NotSelected')}
              </span>
            )}
            <span className={`t-font-sans t-text-sm ${bodyClassName}`}>{t(descriptionKey)}</span>
            <span className={`t-font-sans t-text-xs t-font-medium ${noteClassName}`}>{t(packagingKey)}</span>
          </span>
        </span>
      </label>
    </div>
  );
};

export default Omega3ProductSelector;
